import React from 'react';

import { useRouter } from 'next/router';
import { addZeroToOneDecimal } from 'utils/numbersShowingUtils';
import UseModal from 'hooks/use-modal';

import Modal from '@core/components/Modal/Modal';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import ActionButton from '@core/components/actionbutton/ActionButton';
import SubscriptionPaymentStepper from 'components/pages/plans/payment/subscriptionpaymentstepper/SubscriptionPaymentStepper';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { InfoCircle, TickCircle } from 'iconsax-react';

import TikIcon from 'assets/icons/tik-square-2.svg';

import classes from './CompareSectionPro.module.scss';



const ComparePlanPrice = ({ plan }) => {
    const hasDiscount = plan.discounted_price != null;

    return (
        <>
            {hasDiscount &&
                <div className={classes['orginal-price']}>
                    <span className={classes['price-symbol']}>{plan.currency.symbol}</span>{addZeroToOneDecimal(plan.price)}
                </div>
            }
            <div className={classes.price}>
                <div className={classes.currency}>{plan.currency.symbol}</div>
                {addZeroToOneDecimal(hasDiscount ? plan.discounted_price : plan.price)}
                <div className='d-flex align-items-end'>/mo</div>
            </div>
        </>
    );
};

const CompareSectionPro = ({ data, isLoggedIn, toast, period, setPeriod }) => {
    const plusPlan = period === 'Annual' ? data.yearly : data.monthly;
    const proPlan = period === 'Annual' ? data.pro_yearly : data.pro_monthly;


    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip placement='right-end' {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            boxShadow: theme.shadows[1],
            fontSize: 16,
            padding: 15,

        },
    }));

    const router = useRouter();
    const { show, showModal, destroyModal } = UseModal(false);
    const selectPlanHandler = () => {
        if (isLoggedIn) {
            showModal();
        }
        else
            router.push('/login?next=' + router.asPath);
    };

    return (
        <>
            <div className='container'>
                <div className="row d-md-flex d-none justify-content-center">
                    <div className='col-12 col-xl-11 py-5'>
                        <table className={classes['tabl-comapre']}>
                            <thead>
                                <tr>
                                    <td><h1>Compare plans</h1></td>
                                    <td>
                                        <div className={classes['free-title']}>
                                            <h2>Starter</h2>
                                            <div className={classes.price}>
                                                <div className={classes.currency}>{plusPlan.currency.symbol}</div>0<div className='d-flex align-items-end'>/mo</div>
                                            </div>
                                        </div>

                                    </td>
                                    <td>
                                        <div className={classes['premium-title']}>
                                            <h2>Plus</h2>
                                            <ComparePlanPrice plan={plusPlan} />
                                            <div className={classes['popular-badge']}>Most Popular</div>
                                        </div>
                                    </td>
                                    <td><div className={classes['free-title']}>
                                        <h2>Pro</h2>
                                        <ComparePlanPrice plan={proPlan} />
                                    </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Courses & Learning
                                    </td>
                                    <td>
                                    </td>
                                    <td>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Access Course Library
                                        <LightTooltip
                                            title="Access specialized courses designed by Experts to meet the unique needs of the pharmaceutical industry">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        Free Courses only
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Certifications
                                        <LightTooltip
                                            title="Earn shareable certificate of completion to demonstrate your newly acquired skills. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Downloadable Resources
                                        <LightTooltip
                                            title="Access extra resources designed to support your learning and career growth. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        For free courses
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                    <td>
                                        All Courses
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Learn on mobile
                                        <LightTooltip
                                            title="Learn on the go with our intuitive mobile app, available on iOS and Android, giving you the freedom to study anytime, anywhere. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Assessments
                                        <LightTooltip
                                            title="Evaluate your knowledge and track your progress with our comprehensive assessments. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Career Preparation & Job Board
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Career Paths Access
                                        <LightTooltip
                                            title="Expertly chosen courses and tools to become an expert in your desired career.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Career Coaching
                                        <LightTooltip
                                            title="30-minute expert-led coaching sessions every month with our pharma expert.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Toolkit
                                        <LightTooltip
                                            title="A collection of practical tools and documents to help you work faster and more efficient">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        CV Builder
                                        <LightTooltip
                                            title="Create a standout resume with our CV Builder, effortlessly highlighting your skills and achievements for a professional edge.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Professional Profile
                                        <LightTooltip
                                            title="Create a structured profile, optimize it for target roles, and use it to become visible to recruiters and the community.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Career Competency Radar
                                        <LightTooltip
                                            title="Analyze your CV and course progress with AI and compare yourself with professionals and job requirements in your field.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        Limited
                                    </td>
                                    <td>
                                        Unlimited
                                    </td>
                                    <td>
                                        Unlimited
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Personalized Profile URL
                                        <LightTooltip
                                            title="Get a personalized profile URL and build your brand as you advance your career. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Smart CV Analyzer
                                        <LightTooltip
                                            title="Analyze your CV with our smart tool to get insights and suggestions for improvement.">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        Limited
                                    </td>
                                    <td>
                                        Unlimited
                                    </td>
                                    <td>
                                        Unlimited
                                    </td>
                                </tr>
                                <tr className={classes['category-title']}>
                                    <td>
                                        Community
                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                    <td>

                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        Member-only Events
                                        <LightTooltip
                                            title="We invite our Pro members to exclusive events, such best practice workshops, Industry insights, software trends and more. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        -
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        LinkedIn Community
                                        <LightTooltip
                                            title="Gain access to a thriving community of Pharma experts from around the world to network, ask questions, and provide feedback. ">
                                            <InfoCircle size={18} color='#a6a5a3' />
                                        </LightTooltip>
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                    <td>
                                        <TickCircle />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                header={true}
            >
                <SubscriptionPaymentStepper
                    closeHandler={destroyModal}
                    toast={toast}
                    period={period}
                    setPeriod={setPeriod}
                />
            </Modal>
        </>
    );
};

export default CompareSectionPro;